import React, { memo } from 'react';
import { withStyles, makeStyles } from '@mui/styles';
import stylesheet from "../detail-container.stylesheet";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { Tooltip } from '@mui/material';
import { useThemeMode } from '../../../../contexts/ThemeContext';
import { adjustColorForDarkMode } from '../../../../utils/color-utils';

interface IProps {
  selectedProgramList: string[];
  overridenProgramList?: string[]
}

const useStyles = makeStyles(() => ({
  dot: {
    height: '0.3rem',
    width: '0.3rem',
    borderRadius: '50%',
    display: 'inline-block',
    marginLeft: '0.1rem',
    verticalAlign: 'middle',
  },
  dotOverrideProgram: {
    height: '0.3rem',
    width: '0.3rem',
    border: '2px solid #ffb573',
    borderRadius: '50%',
    display: 'inline-block',
    marginLeft: '0.1rem',
    verticalAlign: 'middle',
  }
}));

const ColorBubbleComponent: React.FC<IProps> = ({ selectedProgramList = [], overridenProgramList = [] }) => {
  const classes = useStyles();
  const { mode } = useThemeMode();
  const isDarkMode = mode === 'dark';
  const programsList = useSelector(
    (state: RootState) => state.metaData.metadata.PROGRAMS || []
  );

  return (<>
    {selectedProgramList.map((e: any, i: number) => {
      const currPrg = programsList.find((f: { name: any; }) => f.name === e) || {} as any
      const adjustedColor = adjustColorForDarkMode(currPrg?.color || '', isDarkMode);
      if (!overridenProgramList.includes(e)) {
        return (<Tooltip title={currPrg.display_name || e}>
          <span key={`cb-${i}`} data-testid='color-testId' className={classes.dot}
            style={{ backgroundColor: adjustedColor }}
          />
        </Tooltip>)
      }
      else {
        return (<Tooltip title={currPrg.display_name || e}>
          <span key={`cb-${i}`} data-testid='color-testId' className={classes.dotOverrideProgram}
            style={{ backgroundColor: adjustedColor }}
          />
        </Tooltip>)
      }
    }
    )}
  </>)
}

export default memo(withStyles(stylesheet)(ColorBubbleComponent));